import { Control, Controller, Path } from "react-hook-form";
import FormSelect, {
  FormSelectProps,
} from "../../../../components/reusable-components/form/FormSelect";
import { PageCreationType } from "../../models/enums/PageCreationType";

export const PageCreationTypeOptions = [
  { label: "Manual", value: PageCreationType.Manual },
  { label: "Automatic", value: PageCreationType.Automatic },
];

interface Props<T extends Record<string, any>>
  extends Omit<FormSelectProps<T>, "label" | "options"> {}

const PageCreationTypeSelect = <T extends Record<string, any>>({
  ...all
}: Props<T>) => {
  return (
    <FormSelect
      label="Page Creation Type"
      options={PageCreationTypeOptions}
      {...all}
    />
  );
};

export default PageCreationTypeSelect;
